import {
  getMenuItem,
  OPERATOR_DATA_SECTION,
  OPERATOR_OPS_GROUPS,
  OPERATOR_SUBSCRIPTIONS_SECTION,
} from './index'
import { resolveSidebarUserSections, SIDEBAR_MENU_AUDIENCE } from './sidebarMenuLayout'
import { isMenuItemVisible } from './menuVisibility'
import { sectionHasVisibleItems, simpleSectionHasVisibleItems } from '../../components/ShellMenuPanel'

export const MENU_OVERVIEW_PATH = '/menu-overview'

function visibleItemsInGroup(group, ctx, audience) {
  return (group.itemIds || [])
    .map((id) => getMenuItem(id))
    .filter((item) => item && isMenuItemVisible(item, ctx, { audience }))
}

/** 메뉴 전체보기 페이지·그리드용 섹션 수집 */
export function collectOverviewSections(menuCtx) {
  const blocks = []
  const { isOperator, showDashboard } = menuCtx

  if (showDashboard) {
    const dash = getMenuItem('dashboard')
    if (dash) blocks.push({ id: 'dashboard', label: '대시보드', items: [dash] })
  }

  const userSections = resolveSidebarUserSections(isOperator)
  userSections.forEach((section) => {
    if (!menuCtx[section.visibilityKey]) return
    if (!sectionHasVisibleItems(section, menuCtx)) return
    const audience = section.audience || SIDEBAR_MENU_AUDIENCE
    const items = []
    ;(section.groups || []).forEach((group) => {
      items.push(...visibleItemsInGroup(group, menuCtx, audience))
    })
    if (items.length) blocks.push({ id: section.id, label: section.label, items })
  })

  if (isOperator && simpleSectionHasVisibleItems(OPERATOR_SUBSCRIPTIONS_SECTION.itemIds, menuCtx)) {
    blocks.push({
      id: 'subscriptions',
      label: OPERATOR_SUBSCRIPTIONS_SECTION.label,
      items: OPERATOR_SUBSCRIPTIONS_SECTION.itemIds.map((id) => getMenuItem(id)).filter(Boolean).filter((item) => isMenuItemVisible(item, menuCtx)),
    })
  }

  if (menuCtx.showDataMgmtMenu) {
    blocks.push({
      id: 'data',
      label: OPERATOR_DATA_SECTION.label,
      items: OPERATOR_DATA_SECTION.itemIds.map((id) => getMenuItem(id)).filter(Boolean).filter((item) => isMenuItemVisible(item, menuCtx)),
    })
  }

  if (menuCtx.showOpsMgmtMenu) {
    OPERATOR_OPS_GROUPS.forEach((group) => {
      const items = (group.itemIds || [])
        .map((id) => getMenuItem(id))
        .filter((item) => item && isMenuItemVisible(item, menuCtx))
      if (items.length) blocks.push({ id: `ops-${group.title}`, label: group.title, items })
    })
  }

  return blocks
}
